import DataModel from '@ember-data/model';
import { cached } from '@glimmer/tracking';
import uniq from 'lodash-es/uniq';
import {
  FilterId,
  FilterOptionsType,
  MultiSelectFilter,
} from 'uplisting-frontend/utils/filters/abstract';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export class AirbnbLinkFilter extends MultiSelectFilter<
  ModelRegistry['airbnb-official-link']
> {
  id = FilterId.airbnbOfficialLink;
  optionsType = FilterOptionsType.store;
  modelName = 'airbnb-official-link';
  modelField = 'nickname' as keyof DataModel;

  @cached
  get models(): ModelRegistry['airbnb-official-link'][] {
    const models = super.models as ModelRegistry['airbnb-official-link'][];

    const validModels = models.filter((item) => item.property);

    const ids = validModels.map((item) =>
      item.belongsTo('airbnbOfficialConnection').id(),
    );

    const records = ids
      .map((id) => this.store.peekRecord('airbnb-official-connection', id))
      .filter((item) => item)
      .flatMap((item) => item.airbnbOfficialLinks)
      .filter((link) => link.property);

    return uniq(records);
  }
}
